import { useEffect, useRef } from 'react';
import { useSelector, useDispatch, shallowEqual } from 'react-redux';
import { SG_GET_MY_SLACK_WORKSPACES } from 'constants/actions';

/**
 * Custom hook to get the current Slack workspace ID
 * Fetches workspaces on first mount if not already loaded
 * @returns {string|null} The current workspace ID or null
 */
export const useWorkspaceId = () => {
  const dispatch = useDispatch();
  const fetchedRef = useRef(false);
  
  const { workspaces, currentWorkspaceId } = useSelector(
    (state) => ({
      workspaces: state.slack_tasks?.myWorkspaces || [],
      currentWorkspaceId: state.slack_tasks?.currentWorkspaceId || null,
    }),
    shallowEqual
  );

  useEffect(() => {
    // Only fetch once if we don't have workspaces yet
    if (workspaces.length === 0 && !fetchedRef.current) {
      fetchedRef.current = true;
      dispatch({ type: SG_GET_MY_SLACK_WORKSPACES });
    }
  }, []); // Empty deps - only run once on mount

  return currentWorkspaceId;
};
